// extracted by mini-css-extract-plugin
export default {"search_input":"C9jkm1N9TRjiD89eqNIj"};